"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  ins: {
    insureType: 'types of insurance',
    invoiceType: 'Invoice Type',
    invoiceDate: 'Invoice Time',
    payStatus: 'Payment Status',
    creator: 'Operator',
    feeType: 'Expense Type',
    insCompanyName: 'Insurance Companies/Associations',
    dueDate: 'Expiration Time',
    payDate: 'Payment Time',
    underwriteDates: 'Underwriting Time',
    voyageNoInsuranceInvoice: 'Voyage insurance invoice registration',
    voyageNoInsuranceInvoice2: 'Voyage insurance invoice registration',
    insClaim: {
      ispFleetCode: 'Fleet Name',
      vesselName: 'Vessel Name',
      voyageNo: 'Voyage No',
      caseCategory: 'Case Categoty',
      caseNo: 'Internal Case No',
      insComCaseNo: 'Insurer Case No',
      dateOfIncident: 'Date of Incident',
      endCaseFlag: 'Status',
      location: 'Location',
      caseName: 'Case Name'
    }
  }
};